import React, { useState } from "react";
import { useGetAllTendersQuery } from "../../Redux/getApi";
import { handleDownload } from "../../utilis/utils";
import { FaDownload } from "react-icons/fa6";
import { MdRemoveRedEye } from "react-icons/md";
import { FiX } from "react-icons/fi";
import dayjs from "dayjs";

export const formatToLongDate = (dateString) => {
  return dayjs(dateString).format("MMMM D, YYYY hh:mm A");
};

const Tenders = () => {
  const [viewFile, setViewFile] = useState(null);
  const { data, error, isLoading, isFetching } = useGetAllTendersQuery();
  const loading = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

    const getAuctionStatus = (auction) => {
  const now = new Date();
  const auctionDate = new Date(auction.auctionDate);

  if (auction.alternativeDate) {
    const alternativeDate = new Date(auction.alternativeDate);

    if (now < auctionDate) return "Upcoming";
    if (now >= auctionDate && now < alternativeDate) return "Postponed";
    if (now >= alternativeDate) return "Completed";
  }

  if (now < auctionDate) return "Upcoming";
  return "Completed";
};
  return (
    <div className="flex flex-col gap-10  md:py-20 py-10 xl:px-[5%] lg:px-[3%] md:px-[2%] px-[6%] ">
      <div className="flex flex-col gap-4">
        <h1 className="xl:text-[2.5rem] lg:text-[1.8rem]  text-[2rem] font-bold text-center">
          Tenders / Auctions
        </h1>
        <p className="xl:text-[1.2rem] md:text-[1rem] text-[.9rem] text-center text-[#7A7A7A]">
          Follow for tenders / auctions issued and advertised by Rawalpindi{" "}
          <br className="hidden sm:block" /> Development Authority
        </p>
      </div>

      {isFetching || isLoading ? (
        <div className=" grid md:grid-cols-2 grid-cols-1 lg:gap-8 gap-6 ">
          {loading.map((i) => (
            <div
              key={i}
              className="bg-[#EFEFEF] animate-pulse p-3 rounded-xl flex flex-col gap-1.5"
            >
              <p className=" bg-[#97979750] h-5 rounded-lg animate-pulse w-[90%]"></p>
              <p className=" bg-[#97979750] h-4 rounded-lg animate-pulse w-[70%]"></p>
              <p className=" bg-[#97979750] h-4 rounded-lg animate-pulse w-[50%]"></p>
            </div>
          ))}
        </div>
      ) : (
        data &&
        (data?.tenders?.length === 0 && data?.auctions?.length === 0 ? (
          <div className=" text-center w-full lg:text-[3rem] md:text-[2rem] text-[1.4rem] font-semibold text-[#000000]">
           Currently, there are no active tenders / auctions.
          </div>
        ) : (

          <div className="grid md:grid-cols-2 grid-cols-1 lg:gap-8 gap-6">
            {data?.tenders?.map((t, i) => (
              <div
                key={i}
                className="bg-[#DEE9E4] lg:p-4 p-3 rounded-2xl flex flex-col lg:gap-3 gap-2"
              >
                <div className="flex justify-between capitalize items-center gap-2 lg:text-[1.8rem] text-[1.5rem] font-semibold text-[#00643b]">
                  <h1>{t?.status} (Tender)</h1>
                  <div className=" flex items-center gap-2">
                    {(t?.doc?.fileType === "application/pdf" ||
                      t?.doc?.fileType?.startsWith("image/")) && (
                      <MdRemoveRedEye
                        className="size-6 cursor-pointer"
                        onClick={() =>
                          setViewFile({
                            url: t?.doc?.docUrl,
                            mimeType: t?.doc?.fileType,
                          })
                        }
                      />
                    )}
                    <button
                      onClick={() =>
                        handleDownload(
                          t?.doc?.docUrl,
                          `${t?.doc?.fileName || "file"}`,
                          t?.doc?.fileType
                        )
                      }
                      className=" text-[#00643b]"
                      aria-label="Download file"
                    >
                      <FaDownload className="size-6 " />
                    </button>
                  </div>
                </div>
                <p className="lg:text-[1.1rem] md:text-[1rem] text-[.85rem]">
                  {t?.title}
                </p>
                <span>
                  <p className="md:text-[1rem] text-[.85rem]">
                    Closing Date: {formatToLongDate(t?.closingDate)}
                  </p>
                  <p className="md:text-[1rem] text-[.85rem]">
                    Opening Date: {formatToLongDate(t?.auctionDate)}
                  </p>
                </span>
              </div>
            ))}
            {data?.auctions?.map((a, i) => (
              <div
                key={i}
                className="bg-[#DEE9E4] lg:p-4 p-3 rounded-2xl flex flex-col lg:gap-3 gap-2"
              >
                <div className="flex justify-between capitalize items-center gap-2 lg:text-[1.8rem] text-[1.5rem] font-semibold text-[#00643b]">
                  <h1> {getAuctionStatus(a)} (Auction)</h1>
                  <div className=" flex items-center gap-2">
                    {(a?.doc?.fileType === "application/pdf" ||
                      a?.doc?.fileType?.startsWith("image/")) && (
                      <MdRemoveRedEye
                        className="size-6 cursor-pointer"
                        onClick={() =>
                          setViewFile({
                            url: a?.doc?.docUrl,
                            mimeType: a?.doc?.fileType,
                          })
                        }
                      />
                    )}
                    <button
                      onClick={() =>
                        handleDownload(
                          a?.doc?.docUrl,
                          `${a?.doc?.fileName || "file"}`,
                          a?.doc?.fileType
                        )
                      }
                      className=" text-[#00643b]"
                      aria-label="Download file"
                    >
                      <FaDownload className="size-6 " />
                    </button>
                  </div>
                </div>
                <p className="lg:text-[1.1rem] md:text-[1rem] text-[.85rem]">
                  {a?.title}
                </p>
                <span>
                 <p>
                        Auction Date: {formatToLongDate(a?.auctionDate)}
                      </p>
                      {a?.alternativeDate && (

                        <p>
                        Alternative Date: {formatToLongDate(a?.alternativeDate)}
                      </p>
                      )}
                </span>
              </div>
            ))}
          </div>
        ))
      )}

      {viewFile && (
        <div className="fixed inset-0 bg-black bg-opacity-10 backdrop-blur-sm flex items-center justify-center z-[200]">
          <div className="relative bg-white/80 border border-white/30 backdrop-blur-lg rounded-2xl shadow-xl p-4  w-[90%] h-[95vh]  animate-fade-in text-black">
            <button
              onClick={(e) => {
                e.stopPropagation();
                setViewFile(null);
              }}
              className="absolute top-4 right-4 text-[#00643b]"
              aria-label="Close modal"
            >
              <FiX className="size-6" />
            </button>
            <h2 className="text-[1.5rem] font-bold lg:mb-4 mb-3 text-[#00643b]">
              Tender / Auction file
            </h2>
            {viewFile.mimeType === "application/pdf" ? (
              <iframe
                src={viewFile.url}
                width="100%"
                height="90%"
                className="rounded-[1rem] mt-2"
                title="PDF Preview"
              />
            ) : viewFile.mimeType.startsWith("image/") ? (
              <img
                src={viewFile.url}
                alt="file Preview"
                className="rounded-[1rem] mt-2 w-full h-[90%]  object-contain"
              />
            ) : (
              <p className="text-red-500 mt-4  text-center">
                This file type cannot be previewed.
              </p>
            )}
          </div>
        </div>
      )}

      {error && (
        <p className=" text-red-500 text-center md:text-[1rem] text-sm bg-red-100 p-2 rounded-lg">
          {error?.data?.message || error?.data?.error}
        </p>
      )}
    </div>
  );
};

export default Tenders;
